export default {
    general: {
        name: 'Ime',
        email: 'Email',
        description: 'Opis',
        status: 'Stanje',
        date: 'Datum',
        id: 'ID',
        size: 'Veličina',
        add: 'Dodaj',
        data: 'Podaci',
        more_info: 'Više informacija',
        all: 'Svi',
        clear_filters: 'Poništi filtere',
        expand_columns: 'Proširi stupce',
        filter_mode: 'Način filtriranja',
        filter_contains: 'Sadrži',
        filter_not_contains: 'Ne sadrži',
        filter_equals: 'Jednako',
        filter_not_equals: 'Nije jednako',
        filter_starts_with: 'Počinje s',
        filter_ends_with: 'Završava s',
        filter_less_than: 'Manje od',
        filter_less_than_or_equal: 'Manje ili jednako',
        filter_greater_than: 'Veće od',
        filter_greater_than_or_equal: 'Veće ili jednako',
        filter_in_range: 'U rasponu',
        filter_before: 'Prije',
        filter_after: 'Poslije',
        filter_from: 'Od',
        filter_to: 'Do',
        reload: 'Osvježi',
        reset_column_widths: 'Poništi širine stupaca',
        resize_column: 'Promijeni širinu stupca',
        search: 'Pretraga',
        yes: 'Da',
        no: 'Ne',
        list: 'Lista',
        download: 'Preuzmi',
        approve: 'Potrvdi',
    },
    nav: {
        tasks: 'Zadaci',
        projects: 'Projekti',
        invoices: 'Fakture',
        submit_request: 'Predaj zahtjev',
        logout: 'Odjava',
    },
    task: {
        list_open: 'Otvoreni',
        list_in_confirmation: 'U potvrđivanju',
        list_finished: 'Završeni',
        status_unassigned: 'Nedodijeljeni',
        status_open: 'Dodijeljeni',
        status_in_progress: 'U radu',
        status_waiting: 'Na čekanju',
        status_sent_for_confirmation: 'U potvrđivanju',
        status_confirmed: 'Potvrđeni',
        status_invoiced: 'Fakturirani',
        denied_letter: 'Z',
        title: 'Naziv zadatka',
        branch_office: 'Podružnica',
        assigned_user: 'Dodijeljen',
        added: 'Dodano',
        deadline: 'Rok',
        contact: 'Kontaktna osoba',
        adding_failed: 'Dodavanje zahtjeva nije uspjelo',
    },
    project: {
        leader: 'Vođa projekta',
        total_tasks: 'Ukupno zadataka',
        finished_tasks: 'Završeni zadaci',
        completed: 'Zaključeno',
        offer_id: 'Broj ponude',
        waiting_for_leader: 'Čekanje na potvrdu nositelja projekta',
        waiting_for_client: 'Čekanje na potvrdu stranke',
        finished: 'Projekt završen',
        denial_reason: 'Razlog odbijanja:',
    },
    invoice: {
        number_of_tasks: 'Broj zadataka',
        invoice_file: 'Faktura',
        times: 'Vrijeme',
        transport: 'Put',
        transport_names: 'Vrsta puta',
        kilometers: 'Kilometri',
        total_time: 'Ukupno vrijeme',
        task_ids: 'ID-jevi zadataka',
        files: 'Datoteke',
        finished: 'Zaključeno',
        approved_by: 'Potvrdio',
        open_printout: 'Otvori ispis',
    },
    client: {
        select: 'Klijent',
        change_failed: 'Promjena nije uspjela',
    },
    login: {
        title: 'Prijava',
        subtitle: 'Dobrodošao natrag, prijavi se u svoj račun',
        password: 'Lozinka',
        forgot_password: 'Zaboravljena lozinka?',
        submit: 'Prijava',
        failed: 'Prijava nije uspjela',
        language: 'Jezik',
        reset_password: 'Promijeni lozinku',
        send_reset_mail: 'Pošalji zahtjev',
        reset_text: 'Mail s poveznicom za promjenu lozinke i uputama je poslan!',
        password_reset_success: 'Lozinka je uspješno promijenjena',
        new_password: 'Nova lozinka',
        reset_mail_already_sent: 'E-pošta za ponovno postavljanje lozinke već je poslana',
        back_to_login: 'Natrag na prijavu',
    },
    register: {
        title: 'Registracija',
        last_name: 'Prezime',
        confirm_password: 'Potvrdi lozinku',
        verification_sent: 'Poslan je verifikacijski email!',
        failed: 'Registracija nije uspjela',
    },
    confirm_mail: {
        title: 'Potvrda email adrese',
        confirmed: 'Email adresa je uspješno potvrđena',
        failed: 'Email adresu nije bilo moguće potvrditi',
    },
    errors: {
        generic_error: 'Došlo je do pogreške',
        invalid_data: 'Neispravni podaci',
        not_found: 'Nije pronađeno',
        on_add: 'Pogreška pri dodavanju',
        on_edit: 'Pogreška pri uređivanju',
        unauthorized: 'Neovlašteno',
        page_not_found: 'Stranica nije pronađena',
        back_home: 'Natrag na početnu stranicu',
    },
    success: {
        add: 'Uspješno dodano',
        edit: 'Uspješno ažurirano',
    },
    validation: {
        required: 'Ovo polje je obavezno',
        email: 'Neispravna e-mail adresa',
    },
    brand: {
        product_name: 'ITOMS',
    },
    layout: {
        open_menu: 'Otvori izbornik',
        close_menu: 'Zatvori izbornik',
    },
    color_mode: {
        switch_to_light: 'Prebaci na svijetli način',
        switch_to_dark: 'Prebaci na tamni način',
    },
}
